import { render, staticRenderFns } from "./MovementStock.vue?vue&type=template&id=bcd1c1d2&scoped=true"
import script from "./MovementStock.vue?vue&type=script&lang=js"
export * from "./MovementStock.vue?vue&type=script&lang=js"
import style0 from "./MovementStock.vue?vue&type=style&index=0&id=bcd1c1d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd1c1d2",
  null
  
)

export default component.exports